module.exports = "/default/images/vendor/lightgallery.js/dist/loading.gif?0aeca8b09888accfccf11976b34c4e64";